define(
    'collections/reports.collection',[
        'loader',
        'config',

        'models/report.model'
    ],
    function(Loader, Config, Model)
    {
        var _ = Loader._;

        var Collection = Loader.Backbone.Collection.extend({
            model: Model,

            update: function(data)
            {
                var _this = this;
                _this.reset();

                _.each(data, function(report){
                    _this.add({
                        id: report.id,
                        userId: report.user.id,
                        userLogin: report.user.login,
                        ip: report.user.ip,
                        report: report.report,
                        topicId: report.topic.id,
                        topicTitle: report.topic.title,
                        postId: report.post.id,
                        isRead: report.is_read,
                        readerId: report.reader ? report.reader.id : null,
                        readerLogin: report.reader ? report.reader.login : null,
                        readTime: report.read_time,
                        time: report.time
                    });
                });
                this.trigger('update');
            }
        });

        return Collection;
    }
);
